import React, {useState} from "react";

import {DatePicker} from "../../../components";


function DateField({fieldObj, fieldIndex, fieldUpdatedFunction, singleLocationMode, readOnly}){
    const [date, setDate] = useState(singleLocationMode || readOnly ? fieldObj.date : undefined)

    const dateChanged = (newDate) => {
        //The date is stored in 'MM/DD/YY' format in Mongo. This is how we get that.
        const formattedDate = newDate.toISOString().split('T')[0]
        fieldObj.date = formattedDate
        setDate(newDate)
        fieldUpdatedFunction(fieldObj)
    }

    const isDisabled = () => {
        if(readOnly){
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }

    return(
        <div className={"mt-2"}>
            <DatePicker
                key={"DatePicker-" + fieldIndex}
                onChange={d => dateChanged(d)}
                date={date}
                dateFormat={'MM/DD/YY'}
                disabled = {isDisabled()}
            />
        </div>
    )


}

export default DateField